exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fission-whitelist-container[data-v-f2c5074e] {\n  padding: 10px 0;\n}\n.pagination-container[data-v-f2c5074e] {\n  margin-top: 16px;\n  text-align: right;\n}\n.member-preview[data-v-f2c5074e] {\n  line-height: 22px;\n  color: #606266;\n  font-size: 13px;\n}\n", ""]);

// exports
